import get from 'lodash/get'
import request from '../../request'
import { createAuthorization } from '../../auth'

/**
 * Get max reach from brooklyn
 */
export async function getMaxReach ({
  auth, server, videoIds, seriesIds,
}) {
  const params = {
    videoIds,
    seriesIds,
  }

  const res = await request
    .get(`${server}/video-analytics/max-reach`)
    .query(params)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .set('content-type', 'application/json')
  return get(res, 'body', {})
}
